


























import { Vue, Component, Mixins } from "vue-property-decorator";
import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  agreementId!: number;

  detailData: { [t: string]: any } = {};

  goBack() {
    history.go(-1);
  }

  async mounted() {
    this.spinLoading = true;
    const query = { ...this.$route.query };
    this.agreementId = Number(query.id);

    const res = await this.$store.dispatch("agreement/detail", {
      id: this.agreementId,
    });

    // console.log(res)
    if (res && res.Data) {
      this.detailData = res.Data;
      // 加载协议条款

      const res1 = await this.$store.dispatch("agreement/items", {
        agreement_id: this.agreementId,
      });
      // console.log(res1)
      if (res1 && res1.Data) {
        this.detailData.items = res1.Data;
      } else {
        this.detailData.items = [];
      }

      console.log(this.detailData);
    }
    this.spinLoading = false;
  }
}
